import { html, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../base-component/base-component';
import { OffCanvasConfigs } from '../../off-canvas/interfaces/off-canvas.interface';
import { WISH_LIST_OFF_CANVAS_IDS } from '../interfaces/wish-list-off-canvas.interface';
import '../../off-canvas/off-canvas';
import '../../wish-list/components/wish-list-create';

@customElement('mhecomm-wish-list-create-off-canvas')
export class WishListCreateOffCanvas extends BaseComponent {
  @property()
  offCanvasTitle = 'Create a New List';

  /**
   * Displays the off-canvas for creating a wishlist.
   */
  renderComp(): TemplateResult | typeof nothing {
    return html`
      <mhecomm-off-canvas .offCanvasConfigs="${this.getOffCanvasConfigs()}">
        <div slot=${WISH_LIST_OFF_CANVAS_IDS.CREATE_WISH_LIST_MY_LISTS + '-off-canvas-body'}>
          <mhecomm-create-wish-list
            offCanvasId="${WISH_LIST_OFF_CANVAS_IDS.CREATE_WISH_LIST_MY_LISTS}"
          ></mhecomm-create-wish-list>
        </div>
      </mhecomm-off-canvas>
    `;
  }

  /**
   * Returns the off-canvas configs for the component.
   *
   * This configuration is updated based on the states.
   */
  private getOffCanvasConfigs(): OffCanvasConfigs {
    return {
      [WISH_LIST_OFF_CANVAS_IDS.CREATE_WISH_LIST_MY_LISTS]: {
        id: WISH_LIST_OFF_CANVAS_IDS.CREATE_WISH_LIST_MY_LISTS,
        title: html`<h5 class="mb-0">${this.offCanvasTitle}</h5>`,
        closeTriggerId: 'cancelWishlistCreationBtn',
        focusElement: '#wishListName',
      },
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-wish-list-create-off-canvas': WishListCreateOffCanvas;
  }
}
